
/*
 * Copyright (c) Aista Ltd, and Thomas Hansen - For license inquiries you can contact thomas@ainiro.io.
 */

import { Component } from '@angular/core';

/**
 * Dialog for showing user terms of service.
 */
@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html'
})
export class TermsModalComponent {
}
